module.exports = __webpack_public_path__ + "static/img/Nicholas-Andreacchio.45a781e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nicholas-Andreacchio.jpg
// module id = 2Vc+
// module chunks = 0